import * as React from 'react';

const Office365Calendar = (props) => (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56.25 53"
    {...props}
  >
    <path
      d="M50 3.5h-4.42V1.25a1.25 1.25 0 0 0-2.5 0V3.5H29.12V1.25a1.25 1.25 0 0 0-2.5 0V3.5h-14V1.25a1.25 1.25 0 0 0-2.5 0V3.5H6.24A6.24 6.24 0 0 0 0 9.75v37A6.24 6.24 0 0 0 6.24 53H50a6.24 6.24 0 0 0 6.24-6.25v-37A6.24 6.24 0 0 0 50 3.5ZM6.24 6h3.88v2.83a1.25 1.25 0 0 0 2.5 0V6h14v2.83a1.25 1.25 0 0 0 2.5 0V6h14v2.83a1.25 1.25 0 0 0 2.5 0V6h4.42a3.74 3.74 0 0 1 3.74 3.75v7.33H2.5V9.75A3.74 3.74 0 0 1 6.24 6ZM50 50.5H6.24a3.74 3.74 0 0 1-3.74-3.75V19.58h51.24v27.17A3.74 3.74 0 0 1 50 50.5Z"/>
    <path d="M39.35 45.72V23.35l-8-2.31-14.43 5.46v16.13l4.92-1.93V27.5l9.52-2.27v19.39l-14.43-2 14.43 5.33 8-2.21Z"/>
  </svg>
);

export default Office365Calendar;
